import AbstractPageBaseController from '../../../core/abstracts/controllers/page-controller';

export default class UsersListController extends AbstractPageBaseController {
    constructor($scope, $injector) {
        super($scope, $injector);

        this.state = this.injector.get('$state');
        this.store = this.injector.get('Users');
        this.store.dispatch('loadWorkflows', 'users::list');
        this.store.commit('setVm', this);

        this._initCurrentView();
    }

    goToGridView() {
        this.state.current.data.collapsedSidebarOnLoad = true;
        this.changeView('grid');
    }

    changeView(newView) {
        this.currentView = newView;
        localStorage.setItem('AlUsersListViewType', newView);
    }

    _initCurrentView() {
        this.currentView = 'grid';

        const localStorageView = localStorage.getItem('AlUsersListViewType');
        if (
            localStorageView
            && (
                localStorageView === 'list'
                || localStorageView === 'grid'
            )
        ) {
            this.currentView = localStorageView;
        }

        this.state.current.data.collapsedSidebarOnLoad = (this.currentView === 'grid');
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/users/controllers/pages/list.js